/** Mirrors server `src/lib/envDomain.js` LABEL_PATTERN for dev-facing copy only. */
const LABEL_PATTERN = /^OD([A-Z])(\d+)-([1-9]\d{4})$/i;

/**
 * @param {string | null | undefined} firstSubdomainLabel e.g. first segment of hostname (odd1-27281 from odd1-27281.localhost)
 * @returns {string | null} Short hint when label does not match production env pattern, else null
 */
export default function customerEnvLabelHint(firstSubdomainLabel) {
  const label = String(firstSubdomainLabel || "").trim();
  if (!label) return null;
  if (LABEL_PATTERN.test(label)) return null;
  return "Use an environment label like odd1-27281 (letter O/D, env letter, digits, hyphen, five-digit customer number), e.g. odd1-27281.localhost for local dev.";
}
